<template>
    <div>
        <ais-instant-search :search-client="searchClient" :index-name="index">

            <section class="flex flex-col w-full">
                <h1 class="w-full p-2 bg-aitems-700 text-gray-100 font-light tracking-wide">
                    {{ trans.get('anomaly.lista') }}
                </h1>
            </section>


            <div class="w-5/6 mx-auto">
                <section class="w-full rounded border shadow-lg mt-10 flex">
                    <div class="w-1/5">

                        <div class="w-3/4 text-center mx-auto p-2 mt-4">
                            <ais-clear-refinements
                                :class-names="{
                                    'ais-ClearRefinements-button': 'btn is-aitems-700'
                                }"
                            >
                                <span slot="resetLabel">Clear Filters</span>
                            </ais-clear-refinements>
                        </div>

                        <div class="w-3/4 mx-auto p-2 mt-10 border shadow">
                            <h2 class="font-bold text-center text-gray-700 tracking-tight uppercase">
                                {{ trans.get('anomaly.modello') }}
                            </h2>
                            <ais-refinement-list attribute="modello"
                                                 class="mt-5"
                                                 :class-names="reflistClasses"
                                                 show-more
                            />
                        </div>
                        <div class="w-3/4 mx-auto p-2 mt-10 border shadow">
                            <h2 class="font-bold text-center text-gray-700 tracking-tight uppercase">
                                {{ trans.get('anomaly.livello') }}
                            </h2>
                            <ais-refinement-list attribute="livello"
                                                 class="mt-5"
                                                 :class-names="reflistClasses"
                            />

                        </div>
                        <div class="w-3/4 mx-auto p-2 mt-10 border shadow">
                            <h2 class="font-bold text-center text-gray-700 tracking-tight uppercase">
                                {{ trans.get('anomaly.costo_totale') }}
                            </h2>
                            <ais-numeric-menu
                                    attribute="costo_totale"
                                    :items="[
                                                { label: 'All' },
                                                { label: '<= 10€', end: 10 },
                                                { label: '10€ - 100€', start: 10, end: 100 },
                                                { label: '100€ - 500€', start: 100, end: 500 },
                                                { label: '>= 500€', start: 500 },
                                            ]"
                            />

                        </div>
                        <div class="w-3/4 mx-auto p-2 mt-10 border shadow">
                            <h2 class="font-bold text-center text-gray-700 tracking-tight uppercase">
                                {{ trans.get('anomaly.parte_1') }}
                            </h2>
                            <ais-refinement-list attribute="parte_1"
                                                 class="mt-5"
                                                 :class-names="reflistClasses"
                                                 show-more
                            />
                        </div>
                        <div class="w-3/4 mx-auto p-2 mt-10 border shadow">
                            <h2 class="font-bold text-center text-gray-700 tracking-tight uppercase">
                                {{ trans.get('anomaly.tipo_anomalia') }}
                            </h2>
                            <ais-refinement-list attribute="tipo_anomalia"
                                                 class="mt-5"
                                                 :class-names="reflistClasses"
                                                 show-more
                            />
                        </div>

                    </div>
                    <div class="w-4/5 table">

                        <div class="w-full flex justify-between p-2 mb-5">
                            <ais-search-box class="w-4/5"/>
                            <ais-sort-by class="ml-2 w-1/5"
                                    :items="[
                                                 { value: 'qms_anomalies', label: trans.get('anomaly.modello_asc') },
                                                 { value: 'qms_anomalies_data_creazione', label: trans.get('anomaly.data_asc') },
                                                 { value: 'qms_anomalies_costo_totale', label: trans.get('anomaly.costo_totale_desc') },
                                            ]"
                            />

                        </div>

                        <section class="mr-2">
                            <ais-hits>
                                <ul slot-scope="{ items }">
                                    <li class="row text-sm" v-for="item in items" :key="item.objectID">
                                        <div class="w-full flex flex-auto justify-start text-gray-700">

                                            <div class="cell w-2/6 justify-between">
                                                <div class="flex flex-col text-left items-start mr-3">
                                                    <a :href="`/qms/anomalies/${item.id}/edit/`"
                                                        class="font-bold text-lg"
                                                    >
                                                        {{ item.codice }}
                                                    </a>
                                                    <span>
                                                        {{ item.data_creazione | reversed }}
                                                     </span>
                                                </div>
                                                <span class="px-4 py-2 rounded-l-full rounded-r-full font-bold"
                                                      :class="`level-badge-${item.livello}`">
                                                      {{ trans.get(`anomaly.${item.livello}`) }}
                                                </span>
                                            </div>

                                            <div class="cell w-1/6 justify-center text-lg">
                                                {{ item.modello }}
                                            </div>

                                            <div class="cell w-2/6 justify-between">
                                                <div class="flex flex-col text-left items-start mr-3">
                                                    <span class="text-lg font-bold">
                                                        {{ item.cod_articolo_parte_1 }}
                                                    </span>
                                                    <span>
                                                        {{ item.parte_1 }}
                                                    </span>
                                                </div>
                                                <div class="px-4 py-2 text-lg font-bold">
                                                    x {{ item.quantita }}
                                                </div>
                                            </div>

                                            <div class="cell w-1/6 justify-center text-lg">
                                                {{ item.tipo_anomalia }}
                                            </div>
                                            <div class="cell w-1/6 justify-end text-lg font-bold">
                                                <div v-if="item.livello === 'medio'">
                                                    <span v-show="!item.costo_totale"
                                                          class="text-orange-600 p-4">
                                                        <i class="fas fa-exclamation-triangle"></i>
                                                    </span>
                                                </div>
                                                <div class="flex flex-col items-center">
                                                    {{ formatter.format(item.costo_totale) }}
                                                    <div class="py-1 px-2 bg-red-700 text-xxs font-bold text-white tracking-tighter uppercase rounded"
                                                         v-text="item.scarto_parte_1 ? trans.get('anomaly.rilavorazione_scarto') : trans.get('anomaly.solo_rilavorazione')"
                                                         v-show="item.costo_totale && item.livello === 'medio'"
                                                    >
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="cell w-1/6">
                                                <a :href="`/qms/anomalies/${item.id}/edit/`">
                                                    <i class="far fa-folder-open"></i>
                                                </a>
                                            </div>
                                        </div>


                                    </li>
                                </ul>
                            </ais-hits>
                        </section>

                        <ais-pagination class="mt-4"/>
                    </div>


                </section>
            </div>


        </ais-instant-search>
    </div>
</template>

<script>
    import Searchable from "../../mixins/Searchable";
    import Utilities from "../../mixins/Utilities";

    export default {

        mixins: [Searchable, Utilities],

        data() {
            return {
                reflistClasses: {
                    'ais-RefinementList-item--selected': 'font-bold',
                    'ais-RefinementList-item': 'ml-2 w-full py-1',
                    'ais-RefinementList-label': 'w-3/4 flex justify-between',
                    'ais-RefinementList-showMore': 'w-full is-aitems-700'
                },
                index: process.env.MIX_QMS_ANOMALIES_INDEX
            }
        }
    }
</script>

<style scoped lang="scss">
    .cell {
        @apply border-r-2 border-b border-gray-100 flex items-center p-4;
    }

    .level-badge-basso {
        @apply bg-green-300 text-green-700;
    }

    .level-badge-medio {
        @apply bg-yellow-300 text-yellow-700;
    }

    .level-badge-critico {
        @apply bg-red-300 text-red-700;
    }

</style>